<script>

import { status } from "../status.js";
import { createEventDispatcher } from 'svelte';
import { slide, fade } from 'svelte/transition';

const dispatch = createEventDispatcher();

// esto lo dejamos para cuando soportemos más de 2 tipos de notificaciones
// let backgroundClass = 'has-background-danger';
// let buttonClass = "is-danger";
// switch con $status.notification.type


</script>


{#if $status.notification.show}
    <div class="modal is-active is-notification">
	<div class="modal-background">
	</div>

	<div class="modal-content">
        <div class="card">
            <div class="card-heading {$status.notification.type === 'DANGER' ? 'has-background-danger' : 'has-background-dark'} ">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item has-text-weight-semibold">
                            {$status.notification.title}
                        </div>
                    </div>
                    
                    <div class="level-right">
                        <div class="level-item">
                            <button class="delete is-large" on:click={() => dispatch("cancel")}></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-content is-clearfix">
                <p>{@html $status.notification.text}</p>
            </div>
            <footer class="card-footer">
                <p class="card-footer-item">
                    <button class="button  {$status.notification.type === 'DANGER' ? 'is-danger' : 'is-dark'}" on:click={() => dispatch("confirm")}>{$status.notification.buttonTextOk}</button>
                </p>
            {#if $status.notification.confirm}
                <p class="card-footer-item">
                    <button class="button" on:click={() => dispatch("cancel")}>{$status.notification.buttonTextCancel}</button>
                </p>
            {/if} 
            </footer>
        </div>
	</div>
</div>
{/if}

{#if $status.message.show}

<article class="message is-success is-small is-temp" transition:slide>
    {#if $status.message.title != ''}
    <div class="message-header has-text-centered has-text-weight-bold">
        <p>{ $status.message.title}</p>
    </div>
    {/if}
    {#if $status.message.text != ''}
    <div class="message-body has-text-left is-size-8">
        {@html $status.message.text}
    </div>
    {/if}
</article>

{/if}